import m from "../../geodata/es2015/bermudaHigh";
window.am4geodata_bermudaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/bermudaHigh.js
// module id = null
// module chunks = 